"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// library components

// Material-UI components

/**
 * formType = default means it's either the combined bank account or the default reimbursement account. If formType is paymentsOnly then it's the bank account for only the premium payments
 * @param formType
 * @param state
 * @param setState
 * @param dispatch
 * @returns {JSX.Element}
 * @private
 */
var EftDetailsForm = function EftDetailsForm(_ref) {
  var formType = _ref.formType,
    eftDetails = _ref.eftDetails,
    handleStateChanges = _ref.handleStateChanges,
    handleChange = _ref.handleChange,
    _ref$accountLevelBank = _ref.accountLevelBankingDetailsView,
    accountLevelBankingDetailsView = _ref$accountLevelBank === void 0 ? false : _ref$accountLevelBank;
  var _eftDetails$formType = eftDetails[formType],
    accountHolder = _eftDetails$formType.accountHolder,
    accountHolderError = _eftDetails$formType.accountHolderError,
    institutionAddress = _eftDetails$formType.institutionAddress,
    institutionName = _eftDetails$formType.institutionName,
    institutionNum = _eftDetails$formType.institutionNum,
    institutionNumError = _eftDetails$formType.institutionNumError,
    transitNum = _eftDetails$formType.transitNum,
    transitNumError = _eftDetails$formType.transitNumError,
    accountNum = _eftDetails$formType.accountNum,
    accountNumError = _eftDetails$formType.accountNumError,
    accepted = _eftDetails$formType.accepted,
    acceptedError = _eftDetails$formType.acceptedError,
    isValidated = _eftDetails$formType.isValidated,
    branchValidationError = _eftDetails$formType.branchValidationError;
  var legalAccessVerbiage = accountLevelBankingDetailsView ? _index.i18n.t(_index.tokens.labels.banking.legalAccessVerbiageAccount) : eftDetails !== null && eftDetails !== void 0 && eftDetails.useSameBankAccount ? _index.i18n.t(_index.tokens.labels.banking.legalAccessVerbiageBoth) : formType === 'default' ? _index.i18n.t(_index.tokens.labels.banking.legalAccessVerbiageDeposit) : _index.i18n.t(_index.tokens.labels.banking.legalAccessVerbiageWithdraw);
  var styles = {
    column: {
      display: 'flex',
      flexDirection: 'column'
    }
  };

  // reset validation state if any user inputs change as form will need to be checked again
  (0, _react.useEffect)(function () {
    handleStateChanges(formType, {
      branchValidationError: false,
      isValidated: false
    });
  }, [institutionNum, transitNum, accountHolder, accountNum, accepted]);

  // Create a ref for each MessageCard
  var validatedMessageCardRef = (0, _react.useRef)(null);
  var branchErrorCardRef = (0, _react.useRef)(null);
  var acceptedErrorRef = (0, _react.useRef)(null);

  // Scroll to the validated MessageCard when it is rendered
  (0, _react.useEffect)(function () {
    if (isValidated && validatedMessageCardRef.current) {
      validatedMessageCardRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (!isValidated && branchValidationError && branchErrorCardRef.current) {
      branchErrorCardRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (acceptedError) {
      acceptedErrorRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isValidated, branchValidationError, acceptedError]);

  /**
   * 
   * @returns 
   */
  var getHeadingText = function getHeadingText() {
    if (eftDetails.useSameBankAccount) {
      return /*#__PURE__*/_react["default"].createElement(_index.Text, {
        large: true,
        bold: true,
        margin: "30px 0 0 0"
      }, _index.i18n.t(_index.tokens.titles.bankingDetails));
    } else if (formType === 'default') {
      return /*#__PURE__*/_react["default"].createElement(_index.Text, {
        large: true,
        bold: true,
        margin: "30px 0 0 0"
      }, _index.i18n.t(_index.tokens.titles.reimbursementAccountDetails));
    }
    return /*#__PURE__*/_react["default"].createElement(_index.Text, {
      large: true,
      bold: true,
      margin: "40px 0 0 0"
    }, _index.i18n.t(_index.tokens.titles.premiumPaymentAccountDetails));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, getHeadingText(), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_index.NumberInput, {
    label: _index.i18n.t(_index.tokens.labels.banking.financialInstitutionNumber),
    onChange: function onChange(e) {
      return handleChange(formType, 'institutionNum', e.target.value, e);
    },
    value: institutionNum,
    error: Boolean(institutionNumError),
    helperText: institutionNumError
  }), /*#__PURE__*/_react["default"].createElement(_index.NumberInput, {
    label: _index.i18n.t(_index.tokens.labels.banking.branchTransitNumber),
    onChange: function onChange(e) {
      return handleChange(formType, 'transitNum', e.target.value, e);
    },
    value: transitNum,
    error: Boolean(transitNumError),
    helperText: transitNumError
  })), /*#__PURE__*/_react["default"].createElement(_index.TextInput, {
    label: _index.i18n.t(_index.tokens.labels.banking.accountHolderName),
    value: accountHolder,
    onChange: function onChange(e) {
      return handleChange(formType, 'accountHolder', e.target.value, e);
    },
    error: Boolean(accountHolderError),
    helperText: accountHolderError || _index.i18n.t(_index.tokens.labels.banking.asItAppearsOnYourCheque),
    fullWidth: true,
    customHelperTextProps: {
      fontFamily: _index.Theme.fonts.type.heading
    }
  }), /*#__PURE__*/_react["default"].createElement(_index.NumberInput, {
    label: _index.i18n.t(_index.tokens.labels.banking.accountNumber),
    value: accountNum,
    onChange: function onChange(e) {
      return handleChange(formType, 'accountNum', e.target.value, e);
    },
    error: Boolean(accountNumError),
    helperText: accountNumError || _index.i18n.t(_index.tokens.labels.banking.ifItStartsWithZeroInclude),
    fullWidth: true,
    customHelperTextProps: {
      fontFamily: _index.Theme.fonts.type.heading
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    error: Boolean(acceptedError),
    ref: acceptedErrorRef
  }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    row: true,
    style: {
      marginTop: 20
    }
  }, acceptedError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    style: {
      marginBottom: 10
    }
  }, acceptedError), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    control: /*#__PURE__*/_react["default"].createElement(_index.Checkbox, {
      checked: accepted,
      onChange: function onChange() {
        return handleChange(formType, 'accepted', !accepted, true);
      },
      value: "acceptedTerms",
      color: "secondary"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_index.Text, {
      avMedium: true,
      customStyle: {
        paddingRight: "5px"
      }
    }, legalAccessVerbiage)
  }))), isValidated && institutionAddress ? /*#__PURE__*/_react["default"].createElement("div", {
    ref: validatedMessageCardRef
  }, /*#__PURE__*/_react["default"].createElement(_index.MessageCard, {
    title: institutionName,
    subtitle: institutionAddress
  })) : null, !isValidated && branchValidationError ? /*#__PURE__*/_react["default"].createElement("div", {
    ref: branchErrorCardRef
  }, /*#__PURE__*/_react["default"].createElement(_index.MessageCard, {
    title: _index.i18n.t(_index.tokens.labels.banking.bankingValidationFailed),
    subtitle: _index.i18n.t(_index.tokens.labels.banking.providedBankCouldNotBeValidated),
    isError: true
  })) : null);
};
var _default = exports["default"] = EftDetailsForm;